import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { loadCampaignTemplates } from '@/store/slices/campaign-templates';
import { selectCampaignTemplates, selectLoadingCampaignTemplates } from '@/store/slices/campaign-templates/selectors';

export const useLoadCampaignTemplates = () => {
  const dispatch = useAppDispatch();
  const templates = useAppSelector(selectCampaignTemplates);
  const loading = useAppSelector(selectLoadingCampaignTemplates);

  useEffect(() => {
    if (!templates.length && !loading) {
      dispatch(loadCampaignTemplates());
    }
  }, [dispatch, templates.length, loading]);

  return { templates, loading };
};
